import "../../../src/main.css";
import React, { useEffect, useState } from "react";
import { OverlayTrigger } from "react-bootstrap";
import { Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FileTextOutlined, UserDeleteOutlined } from "@ant-design/icons";
import { useGroupManagement } from "./store";
import Offcanvas from "react-bootstrap/Offcanvas";
import { Button, List, Select, Space } from "antd";
import { isEmpty } from "lodash";
import { useToast } from "modules/navbar/top/store/toasterStore";
import SoftBadge from "modules/common/SoftBadge";

function OffCanvas({ name, ...props }) {
  const [show, setShow] = useState(false);
  const { groupIdData, idLoading, fetchUserGroup, postUser, deleteRemoveUser } =
    useGroupManagement();
  const { id, userData } = props;
  const [notAddedUsers, setNotAddedUsers] = useState([]);
  const { setToaster } = useToast();
  const [assignId, setAssigneeId] = useState();
  const [message, setMessage] = useState({
    message: "",
    color: "",
  });

  useEffect(() => {
    const init = async () => {
      const findSupervisor = await userData?.find((user) => {
        return user?.user_id === groupIdData[0]?.user?.id;
      });

      const userWithSameType = await userData?.filter((user) => {
        return user?.role_id === findSupervisor?.role_id;
      });

      const nNotAddedUsers = await userWithSameType?.filter((user) => {
        if (user?.user_id === groupIdData[0]?.user?.id) return false;

        return !groupIdData[0]?.userGroup.some(
          (groupId) => groupId?.user_id === user?.user_id
        );
      });

      setNotAddedUsers([...nNotAddedUsers]);
    };

    if (isEmpty(groupIdData)) {
      setNotAddedUsers([]);
    } else {
      init();
    }
  }, [userData, groupIdData]);

  useEffect(() => {
    if (assignId) {
      postUser(
        id,
        { userId: assignId },
        fetchUserGroup,
        setAssigneeId,
        setMessage
      );
    }
  }, [assignId]);

  useEffect(() => {
    if (message) {
      setTimeout(() => {
        setMessage(null);
      }, [2000]);
    }
  }, [message]);

  const removeUser = async (id, user_id) => {
    deleteRemoveUser(id, { userId: user_id }, fetchUserGroup, setMessage);
  };

  const handleShow = () => {
    setShow(true);
    fetchUserGroup(props.id);
  };
  const handleClose = () => {
    setAssigneeId(null);
    setShow(false);
  };

  return (
    <>
      <div variant="primary" className="me-2">
        <div className="d-flex ">
          <OverlayTrigger
            overlay={
              <Tooltip
                style={{ position: "fixed" }}
                id="overlay-trigger-example"
              >
                <div className="fw-bold"> Click to Edit Group Data</div>
              </Tooltip>
            }
          >
            <div className="pe-3" onClick={handleShow}>
              <Button icon={<FileTextOutlined />} type="link" />
            </div>
          </OverlayTrigger>
        </div>
      </div>
      <Offcanvas
        show={show}
        onHide={handleClose}
        {...props}
        style={{ width: "42%" }}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <div className="">
              <div className="d-flex gap-3">
                <div className="d-flex gap-1 align-items-center">
                  <div>Group Name :</div>
                  <div>
                    <SoftBadge bg="info" className="fs-1">
                      {groupIdData[0]?.name}
                    </SoftBadge>
                  </div>
                </div>
                <div className="d-flex  align-items-center">
                  <div>Member in group:</div>
                  <div>
                    <SoftBadge bg="info" className="fs-1">
                      {groupIdData[0]?.userGroup?.length}
                    </SoftBadge>
                  </div>
                </div>
                <div className="d-flex gap-1 align-items-center">
                  <div>Number of member :</div>
                  <div>
                    <SoftBadge bg="info" className="fs-1">
                      {notAddedUsers?.length}
                    </SoftBadge>
                  </div>
                </div>
              </div>
              <div>
                {message ? (
                  <div
                    className={`bg-${message.color} border rounded p-2 my-2 text-white`}
                  >
                    {message?.message}
                  </div>
                ) : (
                  <div className="bg-white p-2 my-2 text-white">message</div>
                )}
              </div>
            </div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="scrollable-container d-flex gap-2 align-items-center mt-n3">
            <Select
              allowClear
              onChange={(selectedRowKeys) => setAssigneeId(selectedRowKeys)}
              optionFilterProp="label"
              placeholder="Select a person"
              showSearch
              style={{ width: "100%" }}
              className=" "
              value={assignId}
            >
              {!isEmpty(notAddedUsers) &&
                notAddedUsers?.map((rep) => (
                  <Option
                    label={rep.user.first_name}
                    value={rep.user_id}
                    key={rep.user_id}
                  >
                    <Space align="center">
                      <div>{rep.user.first_name}</div>
                    </Space>
                  </Option>
                ))}
            </Select>
          </div>
          <div
            className="scrollable-container mt-5"
            style={{
              position: "sticky",
              top: "0",
              maxHeight: "70vh",
              minHeight: "20vh",
              overflowY: "scroll",
            }}
          >
            <List
              dataSource={groupIdData[0]?.userGroup}
              loading={idLoading}
              className=""
              style={{ zIndex: "99999", backgroundColor: "white" }}
              renderItem={(groupId) => (
                <List.Item
                  actions={[
                    <Button
                      danger
                      icon={<UserDeleteOutlined />}
                      onClick={() => removeUser(id, groupId.user_id)}
                      type="link"
                    />,
                  ]}
                >
                  {groupId.user.first_name}
                </List.Item>
              )}
            />
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

function GroupManagementCanvas({ id, userData }) {
  return (
    <>
      <OffCanvas
        key={6}
        id={id}
        userData={userData}
        placement={"end"}
        name={"Filter"}
      />
    </>
  );
}

export default GroupManagementCanvas;
